import { useContext, useEffect, useMemo } from 'react';
import { WebSocketContext } from 'api/services/websocket/websocketProvider';

export const useWebsocket = (
  channel: string,
  subscription: any // can be any shape
) => {
  const wsContext = useContext(WebSocketContext);

  const memoizedSub = useMemo(
    () => subscription,
    [JSON.stringify(subscription)]
  );

  useEffect(() => {
    if (!wsContext?.isConnected || !memoizedSub) return;

    // 🟢 Just subscribe
    wsContext.subscribe({ channel, data: memoizedSub });

    // 🔴 Unsubscribe all when component unmounts or dependencies change
    return () => {
      wsContext.unsubscribe({ channel, data: memoizedSub });
    };
  }, [wsContext?.isConnected, channel, subscription]);
};
